import React, { useEffect, useState } from "react";
import Aos from "aos";
import "aos/dist/aos.css";

import CommonHeaderComp from "../utils/CommonHeaderComp";
import sotryImg1 from "../assets/BannerImg/banner3.png";
import sotryImg2 from "../assets/BannerImg/banner2.png";
import img1Toppings from "../assets/StoryPage/img1Toppings.png";
import img2Toppings from "../assets/StoryPage/Img2Toppings.png";

import "../styles/OurStoryPageStyles/ourStoryStyle.css";
import Breadcrumb from "../components/Breadcrumb";
import OrderBtn from "../utils/OrderBtn";

import blogImg1 from "../assets/BlogPage/blogImg1.png";
import blogImg2 from "../assets/BlogPage/blogImg2.png";
import blogImg3 from "../assets/BlogPage/blogImg3.png";
import blogImg4 from "../assets/BlogPage/blogImg4.png";
import blogImg5 from "../assets/BlogPage/blogImg5.png";
import blogImg6 from "../assets/BlogPage/blogImg6.png";
import StorySlider from "../components/OurStory/StorySlider";
import Footer from "../components/Footer";

import ffImg1 from "../assets/StoryPage/header1.png";
import ffImg2 from "../assets/StoryPage/mf.png";
import StoryDetails from "../components/OurStory/StoryDetails";
import axios from "axios";
import config from "../config";
import { Link } from "react-router-dom";
import Loader from "../utils/Loader";
import { Helmet } from "react-helmet";

const OurStoryPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [storyData, setStoryData] = useState("");
  const [storyBoxData, setStoryBoxData] = useState([]);
  const [bannerImg1, setBannerImg1] = useState("")
  const [bannerImg2, setBannerImg2] = useState("")

  Aos.init({
    offset: 0,
    duration: 1000,
    once: true,
    easing: "ease-out-cubic",
    disable: "phone",
  });

  useEffect(() => {
    fetchStoryData();
    fetchStoryBox();
    fetchBlogs();
  }, []);

  // fetching StoryData
  const fetchStoryData = async () => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append("page", "our story");
    try {
      const response = await axios({
        method: "post",
        url: `${config.apiUrl}/single_blog`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        setIsLoading(false);
        setStoryData(res.data.data);
        setBannerImg1(res.data.data?.post_img);
        setBannerImg2(res.data.data?.post_img2);
        // console.log("story", res.data.data)
      });
    } catch (error) {
      setIsLoading(false);
      console.log("sotry", error);
    }
  };

  // fetching Story Box Data
  const fetchStoryBox = async () => {
    setIsLoading(true);
    try {
      const response = await axios({
        method: "get",
        url: `${config.apiUrl}/story-box`,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        setIsLoading(false);
        setStoryBoxData(res.data.data);
      });
    } catch (error) {
      setIsLoading(false);
      console.log("sotrybox", error);
    }
  };

  const [recentBlogs, setRecentBlogs] = useState([]);

  const fetchBlogs = async () => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append("location", localStorage.getItem("location"));
    try {
      const response = await axios({
        method: "post",
        url: `${config.apiUrl}/posts`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        const resData = res.data.data;
        // console.log("resData",resData);
        const sortedBlogs = resData
          .sort((a, b) => {
            return new Date(b.date) - new Date(a.date);
          })
          .slice(0, 3);
        setRecentBlogs(sortedBlogs);
        setIsLoading(false);
        // console.log("all Blogs 22", sortedBlogs);
      });
    } catch (error) {
      console.log("fetch blogs", error);
      setIsLoading(false);
    }
  };



  return (
    <>
      <Helmet>
        <title>
          Rollz Ice Cream Success Story- Toronto&#039;s Best Desserts Shop
        </title>
        <meta
          name="description"
          content="Rollz Ice Cream proudly offers refreshing vegan drinks, and popping soda available at all Rollz outlets across Canada. Don&#039;t miss this delicious treat."
        />
        <meta
          property="og:title"
          content="Rollz Ice Cream Success Story- Toronto&#039;s Best Desserts Shop"
        />
        <meta
          property="og:description"
          content="Rollz Ice Cream proudly offers refreshing vegan drinks, and popping soda available at all Rollz outlets across Canada. Don&#039;t miss this delicious treat."
        />
      </Helmet>
      {isLoading && <Loader />}
      <div className="OurStoryPage">
        <CommonHeaderComp
          Heading="Our Story"
          height="60vh"
          pageName="Our Story"
          color="white"
        />
        {/* Image 1  */}

        <div className="position-absolute storyImg1 fvfdv" data-aos="fade-left">
          <img
            src={bannerImg1}
            className="img-fluid img1"
            alt="our story img 1"
            loading="lazy"
          ></img>
        </div>

        {/* Image 2  */}
        <div className="position-absolute storyImg2" data-aos="fade-rigth">
          <img
            src={bannerImg2}
            className="img-fluid img2"
            alt="our story img 2"
            loading="lazy"
          ></img>
        </div>

        {/* Story Para  */}
        <section className="story_para_container">
          <div className="d-flex align-items-center justify-content-center story_contianer_wrapper">
            <div className="container d-flex flex-column align-items-center justify-content-center story_content">
              <h3 className="mb-4">
                {storyData?.post_title ||
                  "Indulge in the Rollz Ice Cream Experience!"}
              </h3>
              {/* <h4>
              Refresh yourself with our delightful <span>Fruit Flavours <img src={ffImg1} className="img-fluid" loading="lazy"></img></span> ,
              or get adventurous with our one-of-a-kind{" "}
              <span>Mixed Flavours <img src={ffImg2} className="img-fluid" loading="lazy"></img></span> that will leave you wanting more.
              Served in a cup or popsicle, Rollz Ice Cream is the perfect way to
              treat yourself—whether you're a kid or a kid at heart!
            </h4> */}
              <div>
                <h4>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: storyData?.post_content,
                    }}
                  ></div>
                </h4>
              </div>
            </div>
          </div>
        </section>

        {/* Sotry Slider  */}
        <section className="story_slider">
          <div className="story_contianer">
            <div className="container">
              <div className="d-flex flex-column align-items-center justify-content-center mb-5 story_title">
                <h5 className="mb-2">Our History</h5>
                <h2>How We Started</h2>
              </div>
              <StoryDetails storyBoxData={storyBoxData} />
            </div>
            {/* <StorySlider /> */}
          </div>
        </section>

        {/* Story Blogs  */}
        <section className="story_blogs_container">
          <div className="contianer_wrapper">
            <div className="column-gap-5 d-flex flex-wrap row-gap-sm-5 align-items-start justify-content-center story_blogs">
              {recentBlogs.map((item) => {
                const evenBlog = item.id % 2 === 0;
                const colors = ["#fd85b2", "#eac76f", "#a8a3d8"];
                const bgColor = colors[item.id % colors.length];
                return (
                  <div
                    className={`single_blog mb-5 mb-md-0  d-flex justify-space-between align-items-start  ${evenBlog ? "flex-column-reverse" : "flex-column"
                      }`}
                    key={item.id}
                    style={{ backgroundColor: bgColor }}
                  >
                    <div className="blog_img">
                      <img
                        src={item.post_img}
                        className="img-fluid"
                        loading="lazy"
                      ></img>
                    </div>
                    <div className="blog_content">
                      <h6 className="blog_date mb-3">{item.date}</h6>
                      <h3 className="blog_title mb-3">{item.post_title}</h3>
                      <p className="blog_para">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item?.post_content.slice(0, 150),
                          }}
                        ></div>
                      </p>
                      <div className="order-online">
                        <Link
                          className="blue-btn hero-anchor"
                          to={`${config.appUrl}/blog-details/${item.slug}`}
                        >
                          <div className="order-online-trans-1"></div>
                          <div className="order-online-trans-2"></div>
                          Read More
                        </Link>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* <Footer color="white" /> */}
      </div>
    </>
  );
};

export default OurStoryPage;
